import ScooterCounters from './ScooterCounters';

export default ScooterCounters;
